import { pxToRem } from "adminComponents/utils";

export const Skeleton = {
  baseStyle: (): Record<string, unknown> => ({
    borderRadius: "xl",
    marginY: pxToRem(2),
  }),
};
